import React from "react";
import AppleStore from "../AppleStore/AppleStore";
import GooglePlay from "../GooglePlay/GooglePlay";
import { useTranslation } from "react-i18next";
import {
  Wrapper,
  Card,
  Title,
  Description,
  QRSection,
  QRCode,
  StoreSection,
  StoreButtons,
  Subtitle,
  PrimaryText,
} from "./PersonalRegistrationStep.elements";
import { ReactComponent as BlockBenQr } from "./../../assets/icons/blockben_qr.svg";

export default function PersonalRegistration() {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <PrimaryText>{t("registration.personalStep.mainTitle")}</PrimaryText>
      <Card>
        <Title>{t("registration.personalStep.title")}</Title>
        <Description>{t("registration.personalStep.description")}</Description>
        <QRSection>
          <QRCode>
            <BlockBenQr />
          </QRCode>
        </QRSection>

        {/* TODO Need to add store links */}
        <StoreSection>
          <Subtitle>{t("registration.personalStep.openStores")}</Subtitle>
          <StoreButtons>
            <AppleStore />
            <GooglePlay />
          </StoreButtons>
        </StoreSection>
      </Card>
    </Wrapper>
  );
}
